import * as Types from "actions/types";
import axios from "axios";
import {endpoints} from "variables/variables.jsx";


export function getLocationsPromiseAdmin(user, dispatch){
  let token = user.signInUserSession.idToken.jwtToken;
  
  return axios({
    method: "get",
    url: endpoints.admin+"/location/all/",
    headers: { Authorization: `Bearer ${token}` }
  })
  .then(res => {

      var data = res.data.data;

      dispatch(getLocationsSuccess(data));
      return data;
    })
  .catch((res) => dispatch(getLocationsFailure(res)));  
}

export function getLocationsAdmin(user) {

  return (dispatch, failure) => {
    dispatch(getLocations());
    return getLocationsPromiseAdmin(user, dispatch);
  };
}


export function putLocationAdmin(user, data) {

  return (dispatch, failure) => {
    dispatch(putLocation());
    let token = user.signInUserSession.idToken.jwtToken;

    return axios({
      method: "put",
      url: endpoints.admin+"/location",
      headers: { Authorization: `Bearer ${token}` },
      data
    })
    .then(res => {     
        dispatch(putLocationSuccess(user, data));
        return user;
      })
      .catch(() => dispatch(putLocationFailure()));
  };
}


export function getReceiverLocationsPromise(user, dispatch){
  let token = user.signInUserSession.idToken.jwtToken;
  
  return axios({
    method: "get",
    url: endpoints.public+"/location/all",
    headers: { Authorization: `Bearer ${token}` }
  })
  .then(res => {

      var data = res.data.data;

      dispatch(getLocationsSuccess(data));
      return data;
    })
  .catch((res) => dispatch(getLocationsFailure(res)));  
}

export function getReceiverLocations(user) {

  return (dispatch, failure) => {
    dispatch(getLocations());
    return getReceiverLocationsPromise(user, dispatch);
  };
}

function getLocations() {
  return {
    type: Types.LOCATIONS_GET
  };
}

function getLocationsSuccess(locations) {   
  return {
    type: Types.LOCATIONS_GET_SUCCESS,
    locations
  };
}

function getLocationsFailure(res) {
  return {
    type: Types.LOCATIONS_GET_FAILURE
  }
}


export function postReceiverLocation(user, data) {

  return (dispatch, failure) => {
    dispatch(postLocation());
    let token = user.signInUserSession.idToken.jwtToken;

    return axios({
      method: "post",
      url: endpoints.public+"/location",
      headers: { Authorization: `Bearer ${token}` },
      data
    })
    .then(res => {     
        dispatch(postLocationSuccess(user, data));
        return user;
      })
      .catch(() => dispatch(postLocationFailure()));
  };
}


function postLocation() {
  return {
    type: Types.LOCATION_POST
  };
}

function postLocationSuccess(user, data) {   

  return {
    type: Types.LOCATION_POST_SUCCESS,
  };
}

function postLocationFailure() {
  return {
    type: Types.LOCATION_POST_FAILURE
  }
}


export function putReceiverLocation(user, data) {

  return (dispatch, failure) => {
    dispatch(putLocation());
    let token = user.signInUserSession.idToken.jwtToken;

    return axios({
      method: "put",
      url: endpoints.public+"/location",
      headers: { Authorization: `Bearer ${token}` },
      data
    })
    .then(res => {     
        dispatch(putLocationSuccess(user, data));
        return user;
      })
      .catch(() => dispatch(putLocationFailure()));
  };
}


function putLocation() {
  return {
    type: Types.LOCATION_PUT
  };
}

function putLocationSuccess(user, data) {   

  return {
    type: Types.LOCATION_PUT_SUCCESS,
  };
}

function putLocationFailure() {
  return {
    type: Types.LOCATION_PUT_FAILURE
  }
}

export function deleteReceiverLocation(user, data) {

  return (dispatch, failure) => {
    dispatch(deleteLocation());
    let token = user.signInUserSession.idToken.jwtToken;

    return axios({
      method: "delete",
      url: endpoints.public+"/location",
      headers: { Authorization: `Bearer ${token}` },
      data
    })
    .then(res => {     
        dispatch(deleteLocationSuccess(user, data));
        return user;
      })
      .catch(() => dispatch(deleteLocationFailure()));
  };
}


function deleteLocation() {
  return {
    type: Types.LOCATION_DELETE
  };
}

function deleteLocationSuccess(user, data) {   

  return {
    type: Types.LOCATION_DELETE_SUCCESS,
  };
}

function deleteLocationFailure() {
  return {
    type: Types.LOCATION_DELETE_FAILURE
  }
}


export function getLocationsForCustomerPromise(user, dispatch){
  let token = user.signInUserSession.idToken.jwtToken;
  
  return axios({
    method: "get",
    url: endpoints.public+"/location/suitable",
    headers: { Authorization: `Bearer ${token}` }
  })
  .then(res => {

      var data = res.data.data;

      dispatch(getLocationsSuccess(data));
      return data;
    })
  .catch((res) => dispatch(getLocationsFailure(res)));  
}

export function getLocationsForCustomer(user) {

  return (dispatch, failure) => {
    dispatch(getLocations());
    return getLocationsForCustomerPromise(user, dispatch);
  };
}



// WEBPACK FOOTER //
// ./src/actions/location.js